import { inject, Injectable } from '@angular/core';
import { CONFIG_TOKEN } from '@pxl/models/common';
import { ContactFormService, LoginService } from '@pxl/models/contracts';
import { ContactUsInformationModel, ContactUsModel, HelpService } from '@pxl/shared/generated';
import { Observable } from 'rxjs';

@Injectable()
export class DefaultContactFormService implements ContactFormService {
    private readonly helpBackendService = inject(HelpService);
    private readonly loginService = inject(LoginService);
    private readonly config = inject(CONFIG_TOKEN);

    public getInformation(): Observable<ContactUsInformationModel> {
        return this.helpBackendService.getContactFormInformation(this.config.API_VERSION, this.loginService.getToken());
    }

    public send(reasonId: string, text: string, sendDeviceInfo: boolean, sendCopy: boolean): Observable<void> {
        const model: ContactUsModel = {
            emailContactReasonId: reasonId,
            includeDeviceInformation: sendDeviceInfo,
            sendCopyToUser: sendCopy,
            text: text,
            applicationVersion: this.config.APP_VERSION,
        };
        return this.helpBackendService.send(model, this.config.API_VERSION, this.loginService.getToken());
    }
}
